import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import Side from "../components/Intro"
import Projects from "../components/projects"
import SEO from "../components/SEO"

export default function Project({
  data: {
    allContentfulProjects: { nodes: projects },
  },
}) {
  return (
    <Layout>
      <SEO title="Projects" description="Page for all projects"/>
      <Side isOpen={true}>
        <Projects projects={projects} />
      </Side>
    </Layout>
  )
}

export const query = graphql`
  {
    allContentfulProjects {
      nodes {
        id
        title
        projectUrl
        githubUrl
        description {
          description
        }
        projectImage {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
        tagsModel {
          id
          tagName
        }
      }
    }
  }
`
